import { css, cx } from 'emotion';
import React from 'react';
import pose from 'react-pose';
const Left = pose.div({
  drawerOpen: {
    left: 0,
    flip: true,
    transition: {
      ease: 'easeInOut',
    },
  },
  drawerClosed: {
    left: '-100%',
    flip: true,
    transition: {
      ease: 'easeInOut',
    },
  },
});
const Right = pose.div({
  drawerOpen: {
    right: 0,
    flip: true,
    transition: {
      ease: 'easeInOut',
    },
  },
  drawerClosed: {
    right: ({ size }) => -size,
    flip: true,
    transition: {
      ease: 'easeInOut',
    },
  },
});
const containerStyles = css`
  background: white;
  height: 100%;
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  height: 100%;
  z-index: 99999;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
`;

const Drawer = ({ right = false, size = '100%', isOpen = false, children }) => {
  const Container = right ? Right : Left;
  const initialPosition = right // this is for server side rendering since popmotion doesn't support it
    ? {
        right: `-100%`,
      }
    : {
        left: `-100%`,
      };
  return (
    <Container
      pose={isOpen ? 'drawerOpen' : 'drawerClosed'}
      className={cx(isOpen && 'open', containerStyles)}
      style={Object.assign(
        {
          width: `100%`,
        },
        initialPosition
      )}
      size={size}
    >
      {children}
    </Container>
  );
};

export default Drawer;
